import * as React from "react";
import { Dropdown, Form, Button } from "react-bootstrap";
import "./dropDown.scss";


export class MultiSelectDropDown extends React.Component<any, any> {
  
  constructor(props: any) {
    super(props);
    

    this.state = {
        selectedItems: [],
    };
  }

  handleToggle = (value) => {
    this.setState((prevState) => {
      const selectedItems = [...prevState.selectedItems];
      const index = selectedItems.indexOf(value);
      if (index > -1) {
        selectedItems.splice(index, 1);
      } else {
        selectedItems.push(value);
      }

      this.notifyChange(selectedItems);
      return { selectedItems };
    });
  };

  handleSelectAll = () => {
    const allItems = [...this.props.items];
    this.setState({ selectedItems: allItems });
    this.notifyChange(allItems);
  };

  handleClearAll = () => {
    this.setState({ selectedItems: [] });
    this.notifyChange([]);
  };

  notifyChange = (selectedItems) => {
    if (this.props.onChange) {
      this.props.onChange(selectedItems);
    }
  };

  render() {
    const { items, title, customClass, customHeight, customPadding } = this.props;
    const { selectedItems } = this.state;

    return (
      <Dropdown className={customClass}>
        <Dropdown.Toggle variant="primary" id="dropdown-multiselect" className={`d-flex align-items-center height-${customHeight} padding-${customPadding}`}>
          {title} ({selectedItems.length})
        </Dropdown.Toggle>

        <Dropdown.Menu style={{ padding: '10px', minWidth: '220px' }}>
          <div className="d-flex justify-content-between mb-2">
            <Button size="sm" variant="outline-primary" onClick={this.handleSelectAll}>
              Select All
            </Button>
            <Button size="sm" variant="outline-danger" onClick={this.handleClearAll}>
              Clear All
            </Button>
          </div>
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {items.map((item, index) => (
              <Form.Check
                //custom
                key={index}
                type="checkbox"
                label={item}
                checked={selectedItems.includes(item)}
                onChange={() => this.handleToggle(item)}
              />
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

